export const CHANGE_PASSWORD = '[Account Settings] Change Password';
export const CHANGE_PASSWORD_SUCCESS = '[Account Settings] Change Password Success';
export const CHANGE_PASSWORD_FAILED = '[Account Settings] Change Password Failed';
export const UPDATE_USER_INFO = '[Account Settings] Update user info';
export const UPDATE_USER_INFO_SUCCESS = '[Account Settings] Update user info success';
export const UPDATE_USER_INFO_FAIL = '[Account Settings] Update user info fail';
export const UPDATE_ACCOUNT_SETTINGS = '[Account Settings] Update account settings';
export const UPDATE_ACCOUNT_SETTINGS_SUCCESS = '[Account Settings] Update account settings success';
export const UPDATE_ACCOUNT_SETTINGS_FAIL = '[Account Settings] Update account settings fail';
export const UPDATE_NOTIFICATIONS = '[Account Settings] Update user notifications';
export const UPDATE_NOTIFICATIONS_SUCCESS = '[Account Settings] Update user notifications success';
export const UPDATE_NOTIFICATIONS_FAIL = '[Account Settings] Update user notifications fail';
